import { render, staticRenderFns } from "./modal-card-empty.vue?vue&type=template&id=2cd46aa0"
import script from "./modal-card-empty.vue?vue&type=script&lang=js"
export * from "./modal-card-empty.vue?vue&type=script&lang=js"
import style0 from "./modal-card-empty.vue?vue&type=style&index=0&id=2cd46aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports